import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prepare-stage',
  templateUrl: './prepare-stage.component.html',
  styleUrls: ['./prepare-stage.component.css']
})
export class PrepareStageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
